<div>
    <div class="header">{{ 'bikeshop.users.linked_fittings' | translate }}</div>
    <div class="loading" *ngIf="loading">
        <div class="loader"></div>
    </div>
    <div class="servicetype" *ngIf="!loading">
        <div class="label bold">{{ 'general.select_deselect_all' | translate }}</div>
        <p-inputSwitch (ngModelChange)="updateLinks($event)" [(ngModel)]="allSelected"></p-inputSwitch>
    </div>
    <div class="servicetypes-container" *ngIf="!loading">
        <div *ngFor="let item of items" class="servicetype">
            <div class="label">{{item.groupName}} => {{item.serviceTypeDescription}}</div>
            <p-inputSwitch [(ngModel)]="item.linked" (ngModelChange)="checkMainSelectAll()"></p-inputSwitch>
        </div>
    </div>
    <div class="row margin-top-16" *ngIf="!loading">
        <div class="col-md-9"></div>
        <div class="col-md-3">
            <button pButton type="button" class="p-button-raised full-width"
                    label="{{ 'bikeshop.general.update' | translate }}" [disabled]="saving || loading"
                    (click)="updateItems()"></button>
        </div>
    </div>
</div>
